// extracted by mini-css-extract-plugin
module.exports =  {"Divider":"Divider__A5Fr-"};